export default "__VITE_ASSET__CIhviraY__"